import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { OtpVerificationComponent } from './otp-verification/otp-verification.component';
import { OtpVerificationGuard } from './guards/otp-verification.guard';
import { EmailCodeFormComponent } from './email-code-form/email-code-form.component';
import { emailCodeFormGuard } from './guards/email-code-form.guard';
import { redirectGuard } from './guards/redirect.guard';
import { canAccessGuard } from "./guards/can-access.guard";
import { normalizeRoutePaths } from "./core/routing/normalize-route-paths";


const routes: Routes = normalizeRoutePaths([
  {
    path: "",
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    pathMatch: "full",
  },
  {
    path: "viewer",
    loadChildren: () => import('./dicom-viewer/dicom-viewer.module').then(m => m.DicomViewerModule),
  },
  {
    path: "dicom-unmatched",
    loadChildren: () => import('./dicom-unmatched/dicom-unmatched.module').then(m => m.DicomUnmatchedModule),
  },
  {
    path: "Redirect",
    loadChildren: () => import('./redirect-form/redirect-form.module').then(m => m.RedirectFormModule),
    canActivate: [redirectGuard]
  },
  {
    path: "EmailVerification",
    component: EmailCodeFormComponent,
    canDeactivate: [emailCodeFormGuard],
    canActivate: [canAccessGuard],
    loadChildren:
      () => import('./email-code-form/email-code-form.module').then(m => m.EmailCodeFormModule),
  },
  {
    path: "Welcome",
    loadChildren: () =>
      import('./welcome-component/welcome-component-routing.module').then(m => m.WelcomeRoutingModule),
  },
  {
    path: "ForgetPasswordEmailVerification",
    loadChildren:
      () => import('./email-verification/email-verification.module').then(m => m.EmailVerificationModule),
  },

  {
    path: "Email",
    loadChildren:
      () => import('./patient-selection/patient-selection.module').then(m => m.PatientSelectionModule),
  },
  {
    path: "OTPVerification",
    component: OtpVerificationComponent,
    canDeactivate: [OtpVerificationGuard],
    canActivate: [canAccessGuard],
    loadChildren:
      () => import('./otp-verification/otp-verification.module').then(m => m.OtpVerificationModule),
  },
  {
    path: "WelcomeWindow",
    loadChildren: () => import('./welcome-window/welcome-window.module').then(m => m.WelcomeWindowModule),
  },
  {
    path: "display",
    loadChildren: () => import('./display/display.routes').then(m => m.DISPLAY_ROUTES),
  },
  {
    path: "",
    loadChildren: () => import('./common-layout/common-layout.module').then(m => m.CommonLayoutModule),
  },
  {
    path: "forgot",
    loadChildren:
      () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
  },
  {
    path: "resetpassword",
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule),
  },
  {
    path: "Feedback/:id",
    loadChildren: () =>
      import("./../app/feedback/feedback.module").then((m) => m.FeedBackModule),
  },
  {
    path: "review/:id",
    loadChildren: () =>
      import("../app/shared/component/feedback-preview/feedback-preview.module").then((m) => m.FeedBackPreviewModule),
  },
  {
    path: 'payment-receipt',
    loadChildren: () =>
      import('./payment-receipt-template/payment-receipt-template.module').then(m => m.PaymentReceiptTemplateModule)
  },
  { path: 'payment-mode', loadChildren: () => import('./payment-mode/payment-mode.module').then(m => m.PaymentModeModule) },
  {
    path: "GoogleLoginError",
    loadChildren: () => import('./google-login-error/google-login-error.module').then(m => m.GoogleLoginErrorModule),
  },
  {
    path: "mcp",
    loadChildren: () => import('./mcp/mcp.module').then(m => m.McpModule),
  },
  //{ path: "**", redirectTo: "", pathMatch: "full" },
]);

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
